import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Home from '@/components/home/button1'
import IndexSec from '@/components/ButSecoend/indexSec.vue'
import IndexSec2 from '@/components/ButSecoend2/indexSec2.vue'
import IndexThr from '@/components/ButThr/ButThr_Index.vue'
import IndexFor from '@/components/ButFo_Radar/RadarIndex.vue'
import IndexFiv from '@/components/ButFiv_priceAlert/AlertIndex.vue'
import IndexSix from '@/components/ButSix_vs/VsIndex.vue'
import IndexWar from '@/components/WarRoom/WarIndex.vue'
import ReportLog from '@/components/ReportLog/Index.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/indexSec',
      name: 'IndexSec',
      component: IndexSec
    },
    {
      path: '/indexSec2',
      name: 'IndexSec2',
      component: IndexSec2
    },

    {
      path: '/IndexThr',
      name: 'IndexThr',
      component: IndexThr
    }, {
      path: '/IndexFor',
      name: 'IndexFor',
      component: IndexFor
    }, , {
      path: '/IndexFiv',
      name: 'IndexFiv',
      component: IndexFiv
    },
    {
      path: '/IndexSix',
      name: 'IndexSix',
      component: IndexSix
    },
    {
      path: '/IndexWar',
      name: 'IndexWar',
      component: IndexWar
    },{
      path: '/adminportal',
      name: 'adminportal',
      component: ReportLog
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js